import { Auth0Provider } from "@auth0/auth0-react";

export default function AuthProviderHistory({ children }) {
    const domain = window.REACT_APP_AUTH0_DOMAIN;
    const clientId = window.REACT_APP_AUTH0_CLIENT_ID;
    const audience = window.REACT_APP_AUTH0_AUDIENCE;

    const providerConfig = {
        domain: domain,
        clientId: clientId,
        scope: 'read:users',
        useRefreshTokens: true,
        audience: audience
    };

    return (
        <Auth0Provider {...providerConfig}>
            {children}
        </Auth0Provider>
    );
}